import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getPriceUnitQuery = gql`query get_price_unit{
  price_units(where: {status: {_eq: "ACTIVE"}}, order_by: {name: asc}){
    id
    name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetPriceUnitService {

  constructor(private apollo: Apollo) { }

  getPriceUnit(){
    return this.apollo.use('external').query({
      query: getPriceUnitQuery
    }).pipe(pluck('data', 'price_units'));
  }
}

